export default __webpack_public_path__ + "static/media/animation10.99903339.mp4";